/** 视频容器基础样式 */
export function getVideoContainerStyle() {
  return {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
}

/**
 * 视频样式：始终 contain；旋转 + 翻转在普通窗与全屏均生效
 * @param {{ rotationAngle: number, flipHorizontal: boolean, flipVertical: boolean, isFullscreen?: boolean }} opts
 */
export function getVideoStyle({
  rotationAngle = 0,
  flipHorizontal = false,
  flipVertical = false,
  isFullscreen = false
} = {}) {
  const baseStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: '#000',
    objectFit: 'contain',
    objectPosition: 'center center'
  };

  const transforms = [];
  if (rotationAngle !== 0) transforms.push(`rotate(${rotationAngle}deg)`);
  // 按钮文案按用户观感：左右翻转 ↔ scaleY，上下翻转 ↔ scaleX
  if (flipHorizontal) transforms.push('scaleY(-1)');
  if (flipVertical) transforms.push('scaleX(-1)');

  if (transforms.length === 0) return baseStyle;

  // 90/270 旋转后宽高对调，略缩小以免裁切
  const sideWays = rotationAngle === 90 || rotationAngle === 270;
  const adjustedSize = sideWays ? (isFullscreen ? 72 : 85) : 100;
  return {
    ...baseStyle,
    transform: transforms.join(' '),
    transformOrigin: 'center center',
    width: `${adjustedSize}%`,
    height: `${adjustedSize}%`,
    maxWidth: `${adjustedSize}%`,
    maxHeight: `${adjustedSize}%`
  };
}
